import _ from 'lodash';
import { parse, format } from 'date-fns';
import {
  getRequest,
  postRequest,
  patchRequest
} from '../../Common/network-call';
import {
  DATE_TIME_FORMAT_WITH_SECOND_FNS,
  SCRIPT_URI_ADDON,
  TABLE_URI_ADDON
} from '../../../constants/constant';
import {
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

export const FETCH_USERS = 'FETCH_USERS';
export const OPEN_CHAT = 'OPEN_CHAT';
export const FETCH_CHAT_THREAD = 'FETCH_CHAT_THREAD';
export const FETCH_CHATS = 'FETCH_CHATS';
export const VIEW_USER_MODAL = 'VIEW_USER_MODAL';
export const ATTENDEE_LIST_MODAL = 'ATTENDEE_LIST_MODAL';
export const TIMEOUT_LIST = 'TIMEOUT_LIST';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';
export const FETCH_SUGGESTED_USERS = 'FETCH_SUGGESTED_USERS';
export const OPEN_SUGGESTED_FILTER = 'OPEN_SUGGESTED_FILTER';
export const MEETING_SETTING_OPEN = 'MEETING_SETTING_OPEN';
export const MEETING_SETTINGS = 'MEETING_SETTINGS';

export const fetchUsers = (session, callback) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.networkUsers.chatThreads.endpoint}`;
  let body = _.cloneDeep(SCRIPTS.networkUsers.chatThreads.payload);
  body.eventid = session.eventid;
  body.appuserid = session.userid;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        const notDeniedChatThreads = _.filter(
          response.users,
          thread => thread?.newrequesterstatus !== 'denied'
        );

        dispatch({
          type: FETCH_USERS,
          payload: {
            data: notDeniedChatThreads,
            totalUnread: response.totalUnread
          }
        });
        callback({
          success: 1,
          data: notDeniedChatThreads,
          totalUnread: response.totalUnread
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const searchUsers = (
  session,
  extra = {
    search: '',
    isSuggested: false,
    suggested: {}
  },
  callback = () => {}
) => {
  return dispatch => {
    if (!extra?.isSuggested) {
      let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.networkUsers.chatThreadsSearch.endpoint}`;
      let postBody = _.cloneDeep(
        SCRIPTS.networkUsers.chatThreadsSearch.payload
      );
      postBody.appuserid = session.userid;
      postBody.eventid = session.eventid;
      postBody.search = extra?.search;

      postRequest(
        postUrl,
        postBody,
        session,
        dispatch,
        response => {
          dispatch({
            type: FETCH_USERS,
            payload: { data: response.users, totalUnread: response.totalUnread }
          });
          callback &&
            callback({
              success: 1,
              data: response.users,
              totalUnread: response.totalUnread
            });
        },
        error => {
          callback && callback({ success: 0, message: error });
        }
      );
    } else if (extra?.isSuggested) {
      // ----- clear reducer
      dispatch({
        type: FETCH_SUGGESTED_USERS,
        payload: {}
      });

      // ----- value set
      const dispatchObj = {
        ...extra?.suggested,
        list: !_.isEmpty(extra?.suggested?.list)
          ? _.filter(extra?.suggested?.list, user =>
              _.includes(_.toLower(user?.username), _.toLower(extra?.search))
            )
          : []
      };

      // ----- reducer value set
      dispatch({
        type: FETCH_SUGGESTED_USERS,
        payload: dispatchObj
      });

      // ----- response callback
      callback({
        ...dispatchObj,
        success: 1
      });
    }
  };
};

export function reorderChatUsers(existingArr = [], top, others = {}) {
  var totalUnread = 0;
  _.map(existingArr, obj => {
    totalUnread = parseInt(totalUnread) + parseInt(obj.chatthread[0].unread);

    if (obj.chatthread[0].chatthreadid == top) {
      const today = new Date();
      const str = today.toGMTString(); // Returns format like "Fri, 05 Jul 2024 14:48:00 GMT"
      const dateTimeGMT = parse(
        str,
        "EEE, dd MMM yyyy HH:mm:ss 'GMT'",
        new Date()
      ); // Ensure to include the 'GMT' part
      const dateTime = format(dateTimeGMT, DATE_TIME_FORMAT_WITH_SECOND_FNS);

      obj.chatthread[0].sendon = dateTime;
      obj.chatthread[0].lastsendon = dateTime;
      obj.chatthread[0].chattype = others.chattype;
      obj.chatthread[0].message = others.message;
    }
  });

  existingArr.sort(function compare(a, b) {
    var dateA = new Date(a.chatthread[0].lastsendon);
    var dateB = new Date(b.chatthread[0].lastsendon);
    return dateB - dateA;
  });

  return dispatch => {
    dispatch({
      type: FETCH_USERS,
      payload: { data: existingArr, totalUnread: totalUnread }
    });
  };
}

export const clearUsers = () => {
  return dispatch => {
    dispatch({ type: FETCH_USERS, payload: {} });
  };
};

export function openChat(value) {
  return dispatch => {
    dispatch({ type: OPEN_CHAT, payload: value });
  };
}

export function fetchChatThread(session, targetid, callback) {
  let filter = encodeURI(
    `((eventid=${session.eventid})AND(senderid=${session.userid})AND(receiverid=${targetid}))OR((eventid=${session.eventid})AND(senderid=${targetid})AND(receiverid=${session.userid}))`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chatthread}?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_CHAT_THREAD,
          payload: { data: data.resource, count: data.resource.length }
        });
        callback({
          success: 1,
          data: data.resource,
          count: data.resource.length
        });
      },
      error => {}
    );
  };
}

export function clearChatThread() {
  return dispatch => {
    dispatch({ type: FETCH_CHAT_THREAD, payload: {} });
  };
}

export function fetchChats(session, chatthreadid, callback) {
  var filter = encodeURI(
    `(chatthreadid=${chatthreadid})AND(eventid=${session.eventid})`
  );
  var url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chat}?filter=(${filter})&order=sendon`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        let arr = [];
        if (data.resource.length > 0) {
          _.map(data.resource, chat => {
            // if (
            //   // (chat?.senderid == session.userid ||
            //   //   chat?.receiverid == session.userid) &&
            //   !chat?.senderdeleted &&
            //   !chat?.receiverdeleted
            // ) {
            //   arr.push(chat);
            // } else if (
            //   chat?.senderid == session.userid &&
            //   chat?.senderdeleted &&
            //   !chat?.receiverdeleted
            // ) {
            //   arr.push(chat);
            // } else if (
            //   chat?.receiverid == session.userid &&
            //   chat?.receiverdeleted &&
            //   !chat?.senderdeleted
            // ) {
            //   arr.push(chat);
            // } else {
            //   // arr.push(chat);
            // }
            if (chat?.senderid == session.userid) {
              arr.push(chat);
            } else if (chat?.receiverid == session.userid) {
              // if (!chat?.senderdeleted && !chat?.receiverdeleted)
              arr.push(chat);
            }
          });
        }
        // dispatch({
        //   type: FETCH_CHATS,
        //   payload: { data: data.resource, count: data.resource.length }
        // });
        dispatch({
          type: FETCH_CHATS,
          payload: { data: arr, count: arr.length }
        });
        callback({ success: 1, data: arr });
      },
      error => {}
    );
  };
}

export function blankChatArray() {
  return dispatch => {
    dispatch({ type: FETCH_CHATS, payload: { data: [], count: 0 } });
  };
}

export function clearChats() {
  return dispatch => {
    dispatch({ type: FETCH_CHATS, payload: {} });
  };
}

export function addChatThread(session, resource, callback) {
  var url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chatthread}`;
  var body = {
    resource: resource
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export const updateChatThread = (session, chatthreadid, resource, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chatthread}/${chatthreadid}`;

  return dispatch => {
    patchRequest(
      url,
      resource,
      session,
      dispatch,
      response => {
        dispatch(
          fetchUsers(session, res => {
            callback({ success: 1, response, error: null });
          })
        );
      },
      error => {
        callback({ success: 0, response: null, error });
      }
    );
  };
};

export const updateChatThreadTime = (
  session,
  chatthreadid,
  resource,
  callback
) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chatthread}/${chatthreadid}`;

  return dispatch => {
    patchRequest(
      url,
      resource,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export function addChatMessage(session, resource, callback) {
  var url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chat}`;
  var body = {
    resource: resource.length === 1 ? resource[0] : resource
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export const updateChat = (session, chatid, resource, callback) => {
  var url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chat}/${chatid}`;

  return dispatch => {
    patchRequest(
      url,
      resource,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const updateChatUnread = (session, chatthreadid, callback = null) => {
  let filter = encodeURI(
    `(chatthreadid=${chatthreadid})AND(receiverid=${session.userid})AND(isread=0)`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chat}?filter=(${filter})`;
  let body = {
    resource: [{ isread: 1, eventid: session.eventid }]
  };

  return dispatch => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback && callback({ success: 1, response: response });
      },
      error => {
        callback && callback({ success: 0, error: error });
      }
    );
  };
};

export function viewUserModal(value) {
  return dispatch => {
    dispatch({ type: VIEW_USER_MODAL, payload: value });
  };
}

export function attendeeListModal(value) {
  return dispatch => {
    dispatch({ type: ATTENDEE_LIST_MODAL, payload: value });
  };
}

export function timeoutList(value) {
  return dispatch => {
    dispatch({ type: TIMEOUT_LIST, payload: value });
  };
}

export function showBackScreen(value) {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
}

export const SUGGESTED_REDUCER_STRUCTURE = {
  list: [],
  selectedFilters: null,
  filtered: null
};

export const fetchSuggestedUsers = (session, callback = null) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.networkUsers.suggestionsV2.endpoint}`;
  let body = _.cloneDeep(SCRIPTS.networkUsers.suggestionsV2.payload);
  body.eventid = session.eventid;
  body.appuserid = session.userid;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        let payloadObj = {
          ..._.cloneDeep(SUGGESTED_REDUCER_STRUCTURE),
          list: response.resource
        };
        dispatch({
          type: FETCH_SUGGESTED_USERS,
          payload: payloadObj
        });
        callback &&
          callback({
            data: payloadObj,
            success: 1
          });
      },
      error => {
        callback && callback({ success: 0, data: error });
      }
    );
  };
};

export const openSuggestedFilterList = values => {
  return dispatch => {
    dispatch({ type: OPEN_SUGGESTED_FILTER, payload: values });
  };
};

export const applyFilterOnSuggestedUser = values => {
  return dispatch =>
    dispatch({
      type: FETCH_SUGGESTED_USERS,
      payload: values
    });
};
